module.exports = __webpack_public_path__ + "img/inspiration_img_5.60e96ea9.jpg";